import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Button
} from 'reactstrap';

import Map from './business_prefectures/Map.js';
import Search from './business_prefectures/Search.js';

class BusinessPrefectures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefecture: null,
      businessCounts: null,
      businessTotal: null
    };
  }

  componentDidMount() {
    const { business } = this.props;

    fetch('/api/unifying_factors/' + business).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({
          businessCounts: respJson.businesses,
          businessTotal: respJson.total
        });
      });
  }

  updateBusinessPrefectures(newState) {
    this.setState(newState);
  }

  render() {
    const { businessCounts, businessTotal } = this.state;
    const { business } = this.props;

    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Discover Unifying Factors</div>
            <h1 className="sl-view-title">Select A Prefecture</h1>
            <p className="sl-view-subtitle">Compare where this business is concentrated and move to detailed prefecture analysis.</p>
          </div>
          <span className="sl-view-meta">Step 2 of 3</span>
        </div>

        <Row className="sl-grid-gap">
          <Col md="6">
            <Map
              business={business}
              businessCounts={businessCounts}
              businessTotal={businessTotal} />
            <Button color="primary" tag="a" href="/discover_unifying_factors/index" className="sl-inline-action" outline>
              Back to Businesses
            </Button>
          </Col>
          <Col md="6">
            <Search
              business={business}
              updateBusinessPrefectures={this.updateBusinessPrefectures.bind(this)} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default BusinessPrefectures;
